import { LOCAL_SCRIPT_ICONS } from './scriptIconFiles';

const MONTHS = new Set([
  'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
  'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
]);

const SUFFIXES = new Set([
  'FUT', 'FUTURE', 'FUTURES', 'CE', 'PE', 'CALL', 'PUT',
  'OPT', 'MINI', 'MICRO',
]);

const ALIASES = {
  GOLDM: 'GOLD',
  GOLDGUINEA: 'GOLD',
  GOLDGINEA: 'GOLD',
  GOLDPETAL: 'GOLD',
  SILVERM: 'SILVER',
  SILVERMIC: 'SILVER',
  CRUDEOILM: 'CRUDEOIL',
  NATGASMINI: 'NATURALGAS',
  NATGAS: 'NATURALGAS',
  COPPERM: 'COPPER',
  ZINCMINI: 'ZINC',
  LEADMINI: 'LEAD',
  ALUMINI: 'ALUMINIUM',
  ALUMINIUMMINI: 'ALUMINIUM',
  NIFTY50: 'NIFTY',
  NIFTYNXT50: 'NIFTY',
  CPO: 'COTTON',
  KAPAS: 'COTTON',
  PIDILITE: 'PIDILITIND',
};

const PALETTE = [
  '#D4AF37', '#1B8A5A', '#C45C26', '#2F6FED',
  '#8E44AD', '#16A085', '#C0392B', '#2C3E50',
];

export const resolveScriptKey = (...candidates) => {
  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined) continue;
    const cleaned = String(candidate).replace(/^"+|"+$/g, '').trim().toUpperCase();
    if (!cleaned) continue;

    const tokens = cleaned
      .split(/[\s,_]+/)
      .map((token) => token.replace(/[^A-Z0-9&-]/g, ''))
      .filter(Boolean);

    const symbol = tokens.find((token) => {
      if (SUFFIXES.has(token) || MONTHS.has(token)) return false;
      if (/^\d{2,}$/.test(token)) return false;
      if (/^\d{1,2}[A-Z]{3}\d{0,4}$/.test(token)) return false;
      return /[A-Z]/.test(token);
    });

    if (symbol) {
      return ALIASES[symbol] || symbol;
    }
  }
  return '';
};

export const getLocalIconSrc = (key) => {
  if (!key) return '';
  const fileKey = LOCAL_SCRIPT_ICONS[key]
    ? key
    : (key.replace(/&/g, 'AND'));
  const ext = LOCAL_SCRIPT_ICONS[fileKey];
  if (!ext) return '';
  return `${process.env.PUBLIC_URL || ''}/script-icons/${encodeURIComponent(fileKey)}.${ext}`;
};

export const getRemoteIconSrc = (key) => {
  if (!key) return '';
  return `https://assets-netstorage.groww.in/stock-assets/logos2/${encodeURIComponent(key)}.webp`;
};

export const getScriptInitials = (key, label) => {
  const source = (key || String(label || '')).replace(/^"+|"+$/g, '').trim();
  if (!source) return '?';
  const letters = source.replace(/[^A-Za-z]/g, '');
  return (letters.slice(0, 2) || source.slice(0, 2)).toUpperCase();
};

export const getScriptColor = (key) => {
  const value = key || 'X';
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
};
